module.exports = __webpack_public_path__ + "static/media/ordenate_icon.dd66fce7.png";